module.exports = __webpack_public_path__ + "img/3.3803501b.png";